import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './ProductSelectedHeader.module.scss';

const ProductSelectedHeader = ({ children = null }) => (
  <>
    <div
      className={classnames(
        styles.wrapper,
        styles['cart-added-notification-wrapper'],
      )}
    >
      <div className={classnames(styles.container)}>
        <div className={styles['product-check-mark']} />

        <div className={styles['added-to-cart-wrapper']}>
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </div>
  </>
);

ProductSelectedHeader.propTypes = {
  children: PropTypes.node,
};

export default ProductSelectedHeader;
